import { Goal } from './Goal';

export interface Skill {
  id: number;
  user_id: number;
  name: string;
  description?: string;
  current_level: number;
  created_at: string;
  updated_at: string;
  linkedGoals?: Goal[];
  properties?: { color?: string } | Record<string, any>;
}

export interface SkillFormData {
  name: string;
  description?: string;
  current_level?: number;
  properties?: { color?: string } | Record<string, any>;
}

/**
 * Helper function to safely extract color from skill properties
 */
export function getSkillColor(skill: Skill): string | undefined {
  if (!skill.properties) {
    return undefined;
  }
  
  if (typeof skill.properties === 'object' && 'color' in skill.properties) {
    return skill.properties.color;
  }
  
  return undefined;
}

export interface SkillGoalLink {
  skill_id: number;
  goal_id: number;
}

export interface YearlyProgress {
  year: number;
  expectedLevel: number;
  currentLevel: number | null;
}

export interface SkillProgressTable {
  success: boolean;
  progressTable: YearlyProgress[];
  currentLevel: number;
  linkedGoalsCount: number;
  message?: string;
}

